// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchDataForCatalogSearchPage } from '../../../redux/modules/catalogSearch';
import { getSearchPageSize } from '../../../redux/modules/pagination';
import { parseQueryParams } from '../../../utils/queryParams';
import { recordAnalyticsForCatalogSearchPageView } from '../../../redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const state = getState();
    const pageSize = getSearchPageSize(state);
    const queryParams: any = parseQueryParams(location.search);
    queryParams.pageSize = pageSize; // ignore pageSize in url

    return Promise.all([dispatch(fetchDataForCatalogSearchPage(queryParams))]).then(() => {
        return dispatch(recordAnalyticsForCatalogSearchPageView());
    });
};
